import { useState } from 'react';
import { Cancel, BorderColor } from '@mui/icons-material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { Select, MenuItem } from '@mui/material';

import { deepPurple } from '@mui/material/colors';

import { useSelector } from 'react-redux';

import { axiosInstance } from 'utils/axios';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';

import { toast } from 'react-toastify';

const EditDialog = ({fetchThirdPartyTotalBalance, selectedThirdPartyID, thirdPartyBalanceTypes}) => {
    const token = useSelector(selectCurrentToken);
    const [open, setOpen] = useState(false);

    const [dateLabel, setDateLabel] = useState(dayjs());
    const [amount, setAmount] = useState(0);
    const [balanceType, setBalanceType] = useState(0);

    const [loading, setLoading] = useState(false);

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const handleEdit = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.post(
                '/ThirdParty/Balance/Adjustment',
                {
                    dateLabel: dateLabel.format('YYYY-MM-DD'),
                    balanceTypeID: balanceType,
                    amount: amount,
                    thirdPartyID: selectedThirdPartyID.thirdPartyID
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                setOpen(false); // Close the modal on success
                fetchThirdPartyTotalBalance();
                successAlert('New Party Created Successfully.');
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
                onClick={() => setOpen(true)}
            >
                <BorderColor />
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="thirdparty-package-refund-dialog"
                aria-describedby="thirdparty-package-refund-dialog"
                fullWidth
                maxWidth="md"
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <DialogTitle variant="h3" component="h2">
                        Edit
                    </DialogTitle>

                    <Cancel onClick={() => setOpen(false)} sx={{ width: '30px', height: '30px', marginRight: '10px' }} />
                </Box>

                <DialogContent>
                    <Grid item container xs={12} sx={{ mt: 2 }}>
                        <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Package Refund Date:
                                </Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={dateLabel}
                                        slotProps={{
                                            textField: {
                                                error: false
                                            }
                                        }}
                                        onChange={(newValue) => setDateLabel(newValue)}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Grid>
                        <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Type :
                                </Typography>
                                <Select
                                    displayEmpty
                                    value={balanceType}
                                    onChange={(e) => setBalanceType(e.target.value)}
                                    // sx={{width:"100%"}}
                                >
                                    <MenuItem sx={{ width: '100%' }} value="">
                                        Select Type
                                    </MenuItem>
                                    {thirdPartyBalanceTypes.map((item, index) => {
                                        return (
                                            <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                {item.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </Box>
                        </Grid>
                        <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Amount:
                                </Typography>
                                <input
                                    style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '50px'
                        }}
                        onClick={handleEdit}
                        // disabled={}
                    >
                        Edit
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default EditDialog;
